<template>
  <el-tabs type="border-card" v-model="tabName">
    <el-tab-pane name="workform">
      <template #label>
        <span> 单据信息 </span>
      </template>
      <div style="width: calc( 100% - 10px ); margin:0 auto;padding:5px;">
        <h4 class="form-title">工厂送料单</h4>
        <el-form :model="forms" ref="forms">
          <el-row :gutter="10">
            <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
              <el-form-item label="所属公司" label-width="100px">
                <el-tree-select ref="companys" v-model="forms.companyId" :data="companys" check-strictly
                  @change="companyChange();" :render-after-expand="false"
                  :disabled="!!id || materials.length > 0" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
              <el-form-item label="操作类型" label-width="100px">
                <el-select v-model="forms.billType" placeholder="操作类型" disabled>
                  <!-- :disabled="!!id"  @change="billTypeChange();" -->
                  <el-option v-for="item in dict.billTypes" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
              <el-form-item label="单据编号" label-width="100px">
                <el-input v-model="forms.billCode" placeholder="单据编号" disabled></el-input>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
              <el-form-item label="单据时间" label-width="100px">
                <el-input v-model="forms.billDate" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
              <el-form-item label="操作人员" label-width="100px">
                <el-input v-model="forms.userName" disabled style="width:150px"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
              <el-form-item label="送料总金重" label-width="100px">
                <el-input-number v-model="forms.totalNumber" :min="0" :max="10000000" @change="materialChange()"
                  placeholder="0.00" disabled></el-input-number>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
              <el-form-item label="金料工厂" label-width="100px">
                本地仓
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
              <el-form-item label="金料材质" label-width="100px">
                <el-select v-model="forms.materialCode" placeholder="请选择" @change="materialChange()" :disabled="!!id">
                  <el-option v-for="item in dict.metals" :key="item.id" :label="item.name + '（' + item.value + '）'"
                    :value="item.name"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <el-form-item label="操作备注" label-width="100px">
                <el-input v-model="forms.reason" style="width: 90%;" :disabled="!!id"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col :xs="24" :sm="24" :md="12" :lg="18" :xl="18" style="text-align: left;">
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6" style="text-align: right; margin-top: 10px;">
              <el-button @click="$router.go(-1)">返回</el-button>

              <el-button type="info" @click="itemEvent()" v-if="!id || forms.status == 0">新增明细</el-button>
              <el-button type="primary" @click="sendEvent()" v-if="!id || forms.status == 0">确认送料</el-button>

              <el-button @click="auditMarkEvent()" type="success"
                v-if="id && materials.filter(q => q.remainMark == 20).length > 0">审核损益单</el-button>

              <el-button type="primary" @click="fundEvent()" v-if="forms.status == 2">财务确认</el-button>

            </el-col>
          </el-row>
        </el-form>
        <el-table :data="materials" border stripe size="small" style="margin: 15px auto; width: 100%;">
          <el-table-column type="index" align="center" label="序号" width="45"> </el-table-column>
          <el-table-column prop="billType" label="单据类型" width="90" show-overflow-tooltip> </el-table-column>
          <!-- <el-table-column prop="memo" label="摘要" width="100" show-overflow-tooltip> </el-table-column> -->
          <el-table-column prop="materialCode" label="材质编号" width="75" show-overflow-tooltip> </el-table-column>
          <el-table-column prop="materialName" label="材质名称" width="75" show-overflow-tooltip> </el-table-column>
          <el-table-column prop="factoryName" label="工厂名称" width="220">
            <template #default="scope">
              <el-select v-model="scope.row.factoryName" placeholder="送料工厂" filterable @change="materialChange()"
                :disabled="!!id">
                <el-option v-for="item in dict.factorys" :key="item.value" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="departmentName" label="渠道" width="130" show-overflow-tooltip>
            <template #default="scope">
              <el-select v-model="scope.row.departmentId" placeholder="送出渠道" filterable @change="materialChange();"
                :disabled="!!id">
                <el-option v-for="dd in departments" :key="dd.id" :label="dd.departmentName" :value="dd.id" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="stockNumber" label="操作克重/数量" width="170">
            <template #default="scope">
              <el-input-number v-model="scope.row.stockNumber" :min="-100000" :max="10000000" @change="materialChange()"
                placeholder="0.0000" :precision="4" :disabled="!!id"> </el-input-number>
            </template>
          </el-table-column>
          <el-table-column prop="unitPrice" label="本次单价" width="170">
            <template #default="scope">
              <el-input-number v-model="scope.row.unitPrice" :min="-100000" :max="10000000" :precision="4"
                placeholder="0.00" disabled>
              </el-input-number>
            </template>
          </el-table-column>
          <el-table-column prop="stockPrice" label="总价" width="90" align="right"> </el-table-column>

          <el-table-column prop="remainNumber" :label="id ? '结余数' : '本地仓结余数'" width="100"
            align="right"></el-table-column>
          <el-table-column prop="remainPrice" :label="id ? '结余价' : '本地仓结余价'" width="100"
            align="right"></el-table-column>

          <el-table-column prop="factoryRemainNumber" label="工厂库存数" width="100" align="right"
            v-if="!id"></el-table-column>
          <el-table-column prop="factoryRemainPrice" label="工厂库存价" width="100" align="right"
            v-if="!id"></el-table-column>

          <el-table-column prop="memo" label="标记" width="100"> </el-table-column>
          <el-table-column prop="remark" label="备注" width="150"> </el-table-column>

          <el-table-column label="操作" width="120" fixed="right">
            <template #default="item">
              <el-link @click="materials.splice(materials.indexOf(item.row), 1)" type="primary" size="small" v-if="!id"
                style="margin:5px;">删除</el-link>

              <el-link v-if="id && item.row.status == 100 && item.row.remainMark == 20" type="primary"
                size="small">待审核损益单</el-link>
              <!-- <el-button @click="auditMarkEvent()" type="primary" size="small"
                v-if="id && item.row.status == 100 && item.row.remainMark == 20" style="margin:5px;">审核损益单</el-button> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-tab-pane>
    <!-- <el-tab-pane name="fileform">
      <template #label>
        <span> 表单附件 </span>
      </template>

      <div id="fileform">
        <el-upload
          :action="apiUrl + 'BaseUploader/Basic?dataType=' + opts.formType + '&dataID=' + (opts.uniqueCode || forms.billCode) + '&fileType=form&fileCode=' + opts.billCode"
          list-type="picture-card" :on-success="uploadHandleSuccess" :on-remove="removeHandle"
          :on-preview="previewHandle" :before-upload="uploadHandleBefore" :file-list="opts.files">
          <el-icon>
            <Plus />
          </el-icon>
          <template #file="{ file }">
            <img v-if="file.ext == 'jpg' || file.ext == 'jpeg' || file.ext == 'png' || file.ext == 'bmp'"
              class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
            <div style="font-size: 1em; width: 100%; text-align: center; font-weight: 800; display: flex;
                align-items: center;">
              <span style="overflow-wrap:anywhere">{{ file.name }}</span>
            </div>
            <span class="el-upload-list__item-actions">
              <span class="el-upload-list__item-preview" @click="previewHandle(file)" title="预览">
                <el-icon><zoom-in /></el-icon>
              </span>
              <span class="el-upload-list__item-delete" @click="downloadHandle(file)" title="下载">
                <el-icon>
                  <Download />
                </el-icon>
              </span>
              <span class="el-upload-list__item-delete" @click="removeHandle(file)" title="删除">
                <el-icon>
                  <Delete />
                </el-icon>
              </span>
            </span>
          </template>
        </el-upload>
      </div>
    </el-tab-pane>
    <el-tab-pane name="flownode">
      <template #label>
        <span> 审批记录 </span>
      </template>

      <div id="flownode">
        <el-timeline>
          <el-timeline-item v-for="(record, index) in records" :key="index" :timestamp="record.createDate" center
            :color='(record.actionCode == 10) ? "#79bbff" : (record.actionCode == 50) ? "#67c23a" : record.actionCode == -10 ? "#e6a23c" : record.actionCode == -50 ? "#f56c6c" : ""'
            placement="top">
            <el-card>
              <p><b>审批状态：</b>
                [{{ record.createUserName }}]
                <span v-if="record.actionCode == 0">草稿</span>
                <span style="color:#79bbff" v-else-if="record.actionCode == 10">通过</span>
                <span style="color:#67c23a" v-else-if="record.actionCode == 50">结束</span>
                <span style="color:#e6a23c" v-else-if="record.actionCode == -10">退回</span>
                <span style="color:#f56c6c" v-else-if="record.actionCode == -50">拒绝</span>
                <span v-else>未知</span>
              </p>
              <p><b>审批人员：</b>{{ record.sourceUserName + ' -> ' + record.targetUserName }}</p>
              <p><b>审批动作：</b>{{ record.sourceNodeName + ' -> ' + record.targetNodeName }}</p>
              <p><b>审批意见：</b>{{ record.remark || '无' }}</p>
            </el-card>
          </el-timeline-item>
        </el-timeline>
      </div>
    </el-tab-pane>

    <el-tab-pane name="flowdraw">
      <template #label>
        <span> 审批流程图 </span>
      </template>

      <div id="flowdraw">
        <drawapp ref="drawapp1" :data="drawdata" :height="500" :width="800" :lang="lang" />
      </div>
    </el-tab-pane> -->
  </el-tabs>
</template>
<script>
import drawapp from "@/components/flowDraw";
import flowAudit from "@/views/workflow/flowAudit.vue";
import StaticDialog from "@/components/static-dialog.vue";

// import { getInstance, fetchRecords } from "@/api/workflow";
// import { fetchFileList, delFile } from "@/api/basic";
export default {
  name: "StockMaterialDetail",
  components: { StaticDialog, flowAudit, drawapp },
  data() {
    return {
      tabName: "workform",
      companys: [],
      departments: [],
      id: '',
      dict: {
        factorys: [],
        billTypes: [],
      },

      forms: { "billType": "工厂送料", "materialCode": "Y999", "unitPrice": 0 },
      materials: [],

      latestMaterial: [], // 最新库存信息（历史的合计库存）

      // files: [],
      // userInfo: {},
      // records: [],
      // drawdata: {},
      // opts: {},
      // lang: "zh",
      // apiUrl: '',
    };
  },
  methods: {
    billTypeChange() {
      if (this.id) return;

      let that = this;
      let items = this.dict.billTypes.filter(function (item) {
        return item.value == that.forms.billType;
      });
      //console.log('billTypeChange', that.forms.billType);
      if (items && items.length > 0) {
        this.$kaung.fetch({ url: 'StockMaterialBill/GetBillCode?BillType=' + items[0].value + '&Prev=' + items[0].attribute, method: 'get' })
          .then((res) => {
            that.forms.billCode = 'S-' + res.data;
            that.forms.billDate = that.$util.fmtDate(new Date());
            that.forms.userName = that.$store.getters.getUserInfo.userName;

            this.materialChange();
          });
      }
    },
    companyChange() {
      this.forms.billCode = '';
      this.forms.billDate = '';

      this.forms.departments = null;
      this.departments = [];
      var that = this;
      this.$kaung.departments(this.forms.companyId).then((res) => {
        that.departments = res;
        console.log('companyChange', that.departments);
      });
    },
    materialChange() {
      if ((this.id || '').length > 0) return;

      console.log('materialChange', this.materials);

      this.forms.totalNumber = 0.00;
      let that = this;
      this.materials.forEach(item => {
        //console.log('materialChange index', this.materials.indexOf(item));

        //let metal = that.forms.materialCode ? that.dict.metals.filter(item => item.name == that.forms.materialCode)[0] : {};
        let factory = item.factoryName ? that.dict.factorys.filter(q => q.value == item.factoryName)[0] : {};
        item.factoryCode = factory.name;

        if (!item.departmentId) return;
        let department = that.departments.filter(q => q.id == item.departmentId)[0];
        //console.log('department', department);
        item.departmentId = department.id;
        item.departmentName = department.departmentName;

        //console.log('materialChange', item);
        this.materialInfo(item, this.materials.indexOf(item));

        if (item.stockNumber) { //计算表单总重
          this.forms.totalNumber += item.stockNumber;
        }
      });
    },
    materialInfo(material, index) {
      if (!material || !material.companyId || !material.materialCode || !material.factoryCode || !material.departmentId)
        return;

      let storeFactoryCode = '本地仓';
      this.fetchFactoryMaterial(material.companyId, material.departmentId, material.factoryCode, material.materialCode)
        .then((res) => {
          let lMaterial = res;

          let dItem = this.materials[index];
          dItem.ID = lMaterial.id;
          dItem.factoryRemainNumber = lMaterial.remainNumber;
          dItem.factoryRemainPrice = lMaterial.remainPrice;
        });
      this.fetchFactoryMaterial(material.companyId, material.departmentId, storeFactoryCode, material.materialCode)
        .then((res) => {
          let lMaterial = res;
          if (lMaterial.remainNumber <= 0) {
            this.$message({ type: 'warning', message: '渠道部门在本地仓无金料库存，请先入库后再操作送料' });
          }

          let dItem = this.materials[index];
          dItem.ID = lMaterial.id;
          dItem.remainNumber = lMaterial.remainNumber;
          dItem.remainPrice = lMaterial.remainPrice;
          //dItem.unitPrice = lMaterial.unitPrice; //本次单价，这个单价有问题需要算平均价,最新的平均价=结余总价/结余总重
          dItem.unitPrice = parseFloat((lMaterial.remainPrice / lMaterial.remainNumber).toFixed(4));
          if (dItem.stockNumber)
            dItem.stockPrice = parseFloat((dItem.stockNumber * dItem.unitPrice).toFixed(4));
        });

      // //console.log('materialInfo', material);
      // let lMaterials = this.latestMaterial
      //   .filter(item => (item.companyId || item.companyID) == material.companyId
      //     && (item.departmentId || item.departmentID) == material.departmentId
      //     && item.factoryCode == storeFactoryCode //&& item.factoryCode == material.factoryCode
      //     && item.materialCode == material.materialCode);
      // //console.log('lMaterials', lMaterials);
      // if (lMaterials.length == 0) {
      //   this.$kaung.fetch({
      //     url: 'StockMaterialBill/GetLatestMaterial',
      //     method: 'get',
      //     params: {
      //       CompanyId: material.companyId,
      //       DepartmentId: material.departmentId,
      //       FactoryCode: storeFactoryCode,//要从本地仓出库送去工厂  //material.factoryCode,
      //       MaterialCode: material.materialCode
      //     }
      //   })
      //     .then((res) => {
      //       if (res.code == 200 && res.data) {
      //         let lMaterial = res.data;
      //         lMaterial.companyId = lMaterial.companyID;
      //         lMaterial.departmentId = lMaterial.departmentID;

      //         if (lMaterial.factoryCode = '本地仓' && lMaterial.remainNumber <= 0) {
      //           this.$message({ type: 'warning', message: '渠道部门在本地仓无金料库存，请先入库后再操作送料' });
      //         }

      //         this.latestMaterial.push(lMaterial);
      //         this.bindStoreMaterial(material, index);
      //       }
      //     });
      // } else {
      //   this.bindStoreMaterial(material, index);
      // }
    },
    // //在历史库中查找对应的最新金料信息，和当前选择的关联
    // bindStoreMaterial(material, index) {
    //   let lMaterials = this.latestMaterial
    //     .filter(item => (item.companyId || item.companyID) == material.companyId
    //       && (item.departmentId || item.departmentID) == material.departmentId
    //       && item.factoryCode == '本地仓' //本地仓里面查询是否可以够出库的 //&& item.factoryCode == material.factoryCode
    //       && item.materialCode == material.materialCode);

    //   let dItem = index ? this.materials[index] : this.materials.filter(item => item.departmentId == material.departmentId)[0];
    //   dItem.ID = lMaterials[0].id;
    //   dItem.remainNumber = lMaterials[0].remainNumber;
    //   dItem.remainPrice = lMaterials[0].remainPrice;
    //   //dItem.unitPrice = lMaterials[0].unitPrice; //本次单价，这个单价有问题需要算平均价,最新的平均价=结余总价/结余总重
    //   dItem.unitPrice = parseFloat((lMaterials[0].remainPrice / lMaterials[0].remainNumber).toFixed(2));
    //   if (dItem.stockNumber)
    //     dItem.stockPrice = parseFloat((dItem.stockNumber * dItem.unitPrice).toFixed(2));
    // },
    fetchFactoryMaterial(companyId, departmentId, factoryCode, materialCode) {
      let lMaterials = this.latestMaterial
        .filter(item => (item.companyId || item.companyID) == companyId
          && (item.departmentId || item.departmentID) == departmentId
          && item.factoryCode == factoryCode
          && item.materialCode == materialCode);
      if (lMaterials.length == 1)
        return Promise.resolve(lMaterials[0]);

      return this.$kaung.fetch({
        url: 'StockMaterialBill/GetLatestMaterial',
        method: 'get',
        params: {
          CompanyId: companyId,
          DepartmentId: departmentId,
          FactoryCode: factoryCode,
          MaterialCode: materialCode
        }
      }).then((res) => {
        if (res.code == 200 && res.data) {
          let lMaterial = res.data;
          lMaterial.companyId = lMaterial.companyID;
          lMaterial.departmentId = lMaterial.departmentID;
          this.latestMaterial.push(lMaterial);

          return res.data;
        }
      });
    },

    itemEvent() {
      if (!this.forms || !this.forms.companyId || !this.forms.materialCode)
        return;

      let metal = this.forms.materialCode ? this.dict.metals.filter(item => item.name == this.forms.materialCode)[0] : {};

      let material = {
        companyId: this.forms.companyId,
        billType: this.forms.billType,

        materialName: metal.value || this.forms.materialName,
        materialCode: metal.name || this.forms.materialCode,

      };

      this.materials.push(material);
    },
    sendEvent() {
      if ((this.forms.billType || '').length == 0) {
        this.$message.error('请选择操作类型');
        return;
      }
      if ((this.forms.companyId || '').length == 0) {
        this.$message.error('请选择所属公司');
        return;
      }
      if ((this.forms.materialCode || '').length == 0) {
        this.$message.error('请选择金料/材质类型');
        return;
      }

      let totalNumber = 0.0; let totalPrice = 0.0;
      this.materials.forEach(item => {
        if ((item.stockNumber || 0) <= 0) {
          this.$message.error('请填写明细的操作克重/数量');
          return;
        }
        totalNumber += item.stockNumber;
        totalPrice += item.stockPrice;
      });
      this.forms.totalNumber = totalNumber;
      this.forms.totalPrice = totalPrice;

      let metal = this.forms.materialCode ? this.dict.metals.filter(item => item.name == this.forms.materialCode)[0] : {};
      this.forms.materialName = metal.value;
      this.forms.factoryCode = this.forms.factoryName = '本地仓';

      this.$confirm("确认已送出该批次及对应重量的金料, 本次操作将对该本地仓的批次金料进行出库，是否确认保存？", "提示", { confirmButtonText: "确定", cancelButtonText: "取消", type: "warning", })
        .then(() => {
          let dtos = {
            bill: this.forms,
            details: this.materials,
          };
          let that = this;
          this.$kaung.fetch({
            url: 'StockMaterialBill/SendForm',
            method: 'post',
            data: dtos
          })
            .then((res) => {
              that.$message({ type: res.type, message: res.content });
              if (res.code == 200) {
                that.forms = res.data.bill;
                that.materials = res.data.details;

                that.$router.push({ path: "index", query: { id: that.forms.id } });
              }
            });
        });
    },

    fundEvent() {
      this.$confirm("确认以上单据信息无误，点击保存并归档？", "提示", { confirmButtonText: "确定", cancelButtonText: "取消", type: "warning", })
        .then(() => {
          let that = this;
          this.$kaung.fetch({
            url: 'StockMaterialBill/FundForm?id=' + this.forms.id,
            method: 'post'
          })
            .then((res) => {
              that.$message({ type: res.type, message: res.content });
              if (res.code == 200) {
                that.forms = res.data;
              }
            });
        });
    },

    auditMarkEvent() {
      this.$confirm("该表单存在自动生成的损益单，请确认该损益单信息无误，点击审核通过？", "提示", { confirmButtonText: "确定", cancelButtonText: "取消", type: "warning", })
        .then(() => {
          let that = this;
          this.$kaung.fetch({
            url: 'StockMaterialBill/AuditForm?id=' + this.forms.id,
            method: 'post'
          })
            .then((res) => {
              that.$message({ type: res.type, message: res.content });
              if (res.code == 200) {
                //that.forms = res.data;
                that.materials= res.data.details;
              }
            });
        });
    }
  },
  mounted() {
    this.id = this.$route.query.id || '';
    this.forms.billType = this.$route.query.billType || this.forms.billType;
    if (this.id) {
      this.$kaung.fetch({ url: 'StockMaterialBill/GetBillDto?id=' + this.id, method: 'get' })
        .then((res) => {
          this.forms = res.data.bill;
          this.id = this.forms.id;
          this.materials = res.data.details;
          this.materials.forEach(item => {
            item.companyId = item.companyId || item.companyID;
            item.departmentId = item.departmentId || item.departmentID;
          });

          this.forms.companyId = this.forms.companyID;
          //this.companyChange();
          //this.forms.departments = this.forms.departmentIds.split(',');

          //this.getFlowDraw();
        });
    }
  },
  created() {
    this.apiUrl = process.env.VUE_APP_BASEURL;

    this.$kaung.dictionary("stock", "factory").then((res) => { this.dict.factorys = res.filter(q => !!q.value); });
    this.$kaung.dictionary("stock", "metal").then((res) => { this.dict.metals = res; });
    this.$kaung.dictionary("stock", "material").then((res) => { this.dict.billTypes = res; })
    // .then(() => {
    //   if (!this.id) this.billTypeChange();
    // });

    this.$kaung.companys().then((res) => {
      this.companys = res;
      this.forms.companyId = this.companys[0].id;
      this.companyChange();

      this.billTypeChange();
    });
  },
  watch: {

  },
};
</script>
<style scoped>
.form-title {
  text-align: center;
  margin: 10px auto;
  padding-bottom: 20px;
  color: #000;
  font-size: 1.8em;
  font-weight: 400;
  border-bottom: 4px double #000;
  max-width: 410px;
  letter-spacing: 25px;
}
</style>